// extracted by mini-css-extract-plugin
export default {"searchIcon":"UserHeader_searchIcon__EsN+b"};